import { Collection } from '@nozbe/watermelondb';

import {
    UserAnswerModel,
    UserAnswerPayload,
} from '../../../../types/userAnswer';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareCreateUserAnswer = ({
    payload,
    userID,
    collection,
}: {
    payload: UserAnswerPayload;
    userID: string;
    collection: Collection<UserAnswerModel>;
}) =>
    collection.prepareCreate((userAnswer) => {
        userAnswer.userId = userID;
        userAnswer.answerId = payload.answerId;
    });

export const logAddUserAnswerAction = ({
    userAnswer,
    logDBAction,
    tableName,
}: {
    userAnswer: UserAnswerModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create user answer',
        modelName: tableName,
        payload: userAnswer,
    });
};

export const logBatchAddUserAnswerAction = ({
    userAnswers,
    logDBAction,
    tableName,
}: {
    userAnswers: UserAnswerModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create user answers',
        modelName: tableName,
        payload: userAnswers,
    });
};
